export default [
  'streetName',
  'houseNumber',
  'city',
  'state',
  'postalCode',
  'country',
]
